import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId }, { withCredentials: true });
        await refresh();
        // Clean hash and route to My Kits
        window.history.replaceState(null, "", "/my-kits");
        navigate("/my-kits", { replace: true });
      } catch (err) {
        navigate("/?auth=failed", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="grain min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="animate-spin text-[#8b0000] mx-auto mb-4" size={32} />
        <div className="font-display text-2xl">Unlocking your vault...</div>
      </div>
    </div>
  );
};

export default AuthCallback;
